import app from 'flarum/forum/app';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';
import Stream from 'flarum/utils/Stream';

export default class Uploader {
  constructor() {
    this.callbacks = {
      success: [],
      failure: [],
      uploading: [],
      uploaded: [],
    };
    this.uploading = false;
  }

  on(type, callback) {
    this.callbacks[type].push(callback);
  }

  dispatch(type, response) {
    this.callbacks[type].forEach((callback) => callback(response));
  }

  upload(files, addBBcode = true) {
    this.uploading = true;
    this.dispatch('uploading', files);

    m.redraw(); // Forcing a redraw so that the button also updates if uploadFiles() is called from DragAndDrop or PasteClipboard

    const body = new FormData();

    for (let i = 0; i < files.length; i++) {
      // this.compressionFile(files[i])
      body.append('files[]', files[i]);
    }
    // send a POST request to the api
    return app
      .request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/fof/upload',
        // prevent JSON.stringify'ing the form data in the XHR call
        serialize: (raw) => raw,
        body,
      })
      .then((result) => {
        this.uploaded(result.data[0], addBBcode)
        if (result.data.length > 1) {
          AlertUtil.onWarn(app, result.data[1].id);
        }
      })
      .catch((error) => {
        this.uploading = false;
        m.redraw();

        throw error;
      });
  }

  compressionFile(url) {
    var maxSize = 100 * 1024; // 最大文件大小为100KB
    var img = new Image();
    img.src = url;
    img.onload = function () {
      const _this = this;
      var canvas = document.createElement("canvas");
      var ctx = canvas.getContext("2d");
      var width = img.width;
      var height = img.height;
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(_this, 0, 0, width, height);
      var quality = 0.8;
      let newBase64Image = canvas.toDataURL("image/jpeg", quality);
      let fileSize = this.getBase64ImageSize(newBase64Image);
      if (fileSize > maxSize) {
        const qualityArr = [],
          step = 0.01;
        for (let i = step; i <= quality; i += step) {
          // qualityArr.push(parseFloat(i.toFixed(2)));
          qualityArr.push(parseFloat(i));
        }
        let left = 0,
          right = qualityArr.length - 1;
        do {
          const mid = Math.floor((left + right) / 2);
          newBase64Image = canvas.toDataURL("image/jpeg", qualityArr[mid]);
          fileSize = this.getBase64ImageSize(newBase64Image);
          if (fileSize > maxSize) {
            right = mid - 1;
          } else {
            left = mid + 1;
          }
        } while (left <= right);
      }
    };
    
 
  }

     // 计算base64编码图片大小
    getBase64ImageSize(base64) {
      const indexBase64 = base64.indexOf("base64,");
      if (indexBase64 < 0) return -1;
      const str = base64.substr(indexBase64 + 6);
      // 大小单位：字节
      return (str.length * 0.75).toFixed(2);
}

  uploaded(result, addBBcode = false) {
    this.uploading = false;

    // result.forEach((file) => {
      const fileObj = app.store.pushObject(result);

      // Add file to media manager
      app.fileListState.addToList(fileObj);

      // Dispatch
      this.dispatch('success', {
        file: fileObj,
        addBBcode,
      });
    // });

    this.dispatch('uploaded');
  }
}
